module.exports = __webpack_public_path__ + "img/upData.01a521bf.png";